
import xml2js from 'xml2js'
const parser = new xml2js.Parser()

export const xmlToJSON = async(xml: string): Promise<unknown> => {
  return await parser.parseStringPromise(xml)
}

